export const authenticated = (state) => state.authenticated

export const authenticated_user = (state) => state.authenticated_user

export const selected_control_panel = (state) => state.selected_control_panel

export const selected_company = (state) => state.selected_company

export const selected_order_of_service = (state) => state.selected_order_of_service

export const selected_standard = (state) => state.selected_standard

export const company_dropdown_has_more = (state) =>
  state.company_dropdown.has_more

export const company_dropdown_companies = (state) =>
  state.company_dropdown.companies

export const company_dropdown_page = (state) => state.company_dropdown.page

export const company_dropdown = (state) => state.company_dropdown

export const order_of_service_dropdown_has_more = (state) =>
  state.order_of_service_dropdown.has_more

export const order_of_service_dropdown_orders_of_service = (state) =>
  state.order_of_service_dropdown.orders_of_service

export const order_of_service_dropdown_page = (state) => state.order_of_service_dropdown.page

export const order_of_service_dropdown = (state) => state.order_of_service_dropdown
